import { FC, createElement, useState } from 'react';
import { List, ListProps } from './list';

const VALID_HASHES = ['#services', '#presential'];
const DEFAULT_HASH = '#services';

export const ListContainer: FC = () => {
  const [active, setActive] = useState(() => {
    const hash = typeof window !== 'undefined' ? window.location.hash : '';
    return VALID_HASHES.includes(hash) ? hash : DEFAULT_HASH;
  });

  function handleToggle(hash: string) {
    setActive(hash);
    window.history.replaceState(null, '', hash);
  }

  const props: ListProps = { handleToggle, active };
  return createElement(List, props);
};
